import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Tooltip } from 'react-tippy'
import { bindActionCreators } from 'redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'

import SearchBoxWithSuggestionsFromNetwork from '../../../../../../components/ui/forms/SearchBoxWithSuggestionsFromNetwork'
import * as tuitionDuck from '../../../../../../routes/authenticated/Tuition/tuitionDuck'
import constants from '../../../../../../utils/constants/application'
import notificationsUtils from '../../../../../../utils/notifications/notificationsUtils'
import formValidators from '../../../../../../utils/validation/formValidators'
import renderMultiSelectInput from '../../../../../../components/ui/forms/renderMultiSelectInput'
const { autoCompleteIndices } = constants

class CareerSearchForm extends Component {
  static propTypes = {
    change: PropTypes.func,
    companyFilter: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    isEmptyData: PropTypes.bool,
    isMobile: PropTypes.bool.isRequired,
    result: PropTypes.object,
    companyValue: PropTypes.string,
    universityValue: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      showClearFilterPrompt: false,
    }

    this.checkNoDataWithFilter = () => {
      const { isEmptyData, companyFilter, formValues } = this.props
      const { showClearFilterPrompt } = this.state
      const companyValue = formValues ? formValues['company'] : undefined

      if (isEmptyData && companyValue && companyValue === companyFilter && !showClearFilterPrompt) {
        this.setState({ showClearFilterPrompt: true })
      } else if (!companyValue && showClearFilterPrompt) {
        this.setState({ showClearFilterPrompt: false })
      }
    }

    this.onJobTitleSuggestionSelected = suggestionValue => {
      this.props.change('search_query', suggestionValue)
      this.props.change('exact_match', true)
      setTimeout(() => this.props.handleSubmit(), 200)
    }

    this.onCompanySuggestionSelected = suggestionValue => {
      this.props.change('company', suggestionValue)
      setTimeout(() => this.props.handleSubmit(), 200)
    }
    this.onChangeState = options => {
      this.props.change('state', options)
      setTimeout(() => this.props.handleSubmit(), 200)
    }
    this.onSubmit = e => {
      const { companyValue, searchQueryValue, handleSubmit } = this.props
      e.preventDefault()
      const errors = this.props.validate({
        company: companyValue,
        search_query: searchQueryValue,
      })

      if (Object.values(errors).length === 0) {
        handleSubmit(e)
      }
    }
  }

  componentWillMount() {
    this.checkNoDataWithFilter()
    // this.createJobSuggestions()
    this.props.performRetrieveStates()
  }

  componentDidUpdate() {
    this.checkNoDataWithFilter()
    this.props.change('exact_match', false)
  }

  render() {
    const { isMobile } = this.props
    const { showClearFilterPrompt } = this.state

    return (
      <div>
        <form onSubmit={this.onSubmit}>
          <div className="row">
            <div className="col-md-9">
              <Field
                name="search_query"
                placeholder="What job would you like to have?"
                component={SearchBoxWithSuggestionsFromNetwork}
                field={autoCompleteIndices.jobTitles}
                label="Job Title"
                onSuggestionSelected={this.onJobTitleSuggestionSelected}
                className="LoNotSensitive"
              />
              <Tooltip
                title="Try clearing the filter(s) to broaden your search."
                position="bottom"
                trigger="manual"
                open={showClearFilterPrompt}
                arrow
              >
                {!isMobile && (
                  <div className="row ml-0">
                    <div className="col-md-7 pl-0">
                      <Field
                        name="company"
                        component={SearchBoxWithSuggestionsFromNetwork}
                        field={autoCompleteIndices.companies}
                        placeholder="e.g. Amazon"
                        label="Company Name (optional)"
                        onSuggestionSelected={this.onCompanySuggestionSelected}
                        className="LoNotSensitive"
                        search={false}
                      />
                    </div>
                    <div className="col-md-5 form-group-360" style={{ paddingTop: '9px' }}>
                      <Field
                        onChange={this.onChangeState}
                        name="state"
                        label="US States (Optional)"
                        component={renderMultiSelectInput}
                        options={this.props.states}
                      />
                    </div>
                  </div>
                )}
              </Tooltip>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

// Form validation function run by redux-form
const validate = values => {
  const errors = {}
  if (values) {
    const { search_query, company } = values
    errors.search_query = formValidators.isRequired(search_query)
      ? formValidators.isRequired(search_query)
      : formValidators.maxLengthTwoHundred(search_query)
    if (company) {
      errors.company = formValidators.maxLengthTwoHundred(company)
    }
  }

  return errors
}

const careerSearchForm = reduxForm({
  form: 'careerSearchForm',
  touchOnChange: true,
  onSubmit: async (values, _dispatch, _props) => {
    const { handleSubmit } = _props
    const { state, company, search_query, exact_match } = values

    try {
      if (search_query || company) {
        const searchParams = {
          search_query,
          company,
          state,
          exact_match,
        }
        handleSubmit(searchParams)
      }
    } catch (error) {
      notificationsUtils.showErrorNotification(error.message)
    }
  },
  destroyOnUnmount: false,
  validate,
})(CareerSearchForm)

const selector = formValueSelector('careerSearchForm') // <-- same as form name
// Decorate with connect to read form values
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performRetrieveStates: tuitionDuck.performRetrieveStates,
    },
    dispatch,
  )

const careerSearchFormWithRedux = connect(state => {
  const companyValue = selector(state, 'company')
  const searchQueryValue = selector(state, 'search_query')
  return {
    companyValue,
    searchQueryValue,
    result: state.personalityAssessment.result,
    states: tuitionDuck.states(state.tuition),
  }
}, mapDispatchToProps)(careerSearchForm)

export default careerSearchFormWithRedux



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Career/components/CareerSearchForm.js